<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("menu.coupon") }}
                    </h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <!--
                    Create-event button (spec 2026-09-23 §4). Gated on
                    canCreateCouponEvent, which the server derives per login
                    from config.yml's coupon_event.emails — NOT a role, so it
                    cannot be granted from the User screen. The gate here is
                    cosmetic; POST /api/v1/coupon re-checks it (mw.IsCouponEvent).
                    @click.native, BaseButton re-emits the native click, so plain @click works too; .native is used here so the button behaves the same whether or not the wrapper is a component: base-button
                    renders a native <button>, so the DOM event always fires.
                -->
                <div class="col-lg-6 col-5 text-right" v-if="canCreateCouponEvent">
                    <base-button size="md" type="neutral" @click.native="handleCreate()">{{
                        $t("coupon_event.create_button")
                    }}</base-button>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <div class="row">

                            <div class="col-md-2 col-xs-12">
                                <base-input class="">
                                    <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur"
                                        :config="{ allowInput: true }" :placeholder="$t('time_from')"
                                        class="form-control datepicker" v-model="params.time_from">
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2 col-xs-12">
                                <base-input>
                                    <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur"
                                        :config="{ allowInput: true }" :placeholder="$t('time_to')"
                                        class="form-control datepicker" v-model="params.time_to">
                                    </flat-picker>
                                </base-input>
                            </div>


                            <div class="col-auto">
                                <base-button size="md" @click="handleSearch()">
                                    <i class="fas fa-spinner fa-spin " v-if="isLoading"></i>
                                    {{ $t("search") }}</base-button>

                            </div>
                        </div>


                    </template>
                    <!-- end header -->

                    <div>
                        <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light">
                            <!-- order_number -->
                            <el-table-column align="left" :label="$t('coupon_id')" min-width="80px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.id }} </span>

                                </div>
                            </el-table-column>

                            <!-- created_at -->
                            <el-table-column align="left" :label="$t('name')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.name }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('running_from')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.running_from }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('running_to')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.running_to }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="ส่งแล้ว / ลงทะเบียนแล้ว / จำนวนลูกค้า" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.total_used }} / {{ row.total_register }} / {{ row.total_member }}  </span>
                                </div>
                            </el-table-column>




                            <el-table-column align="right" :label="$t('actions')" min-width="120px">
                                <div slot-scope="{ $index, row }" class="d-flex">

                                    <base-button
                                        @click.native="handleShowDetail(row)" class="edit" type="warning" size="sm"
                                        icon>
                                        <i class="text-dtac-bt fa fa-list"></i>
                                    </base-button>
                                    <!-- <base-button
                                        @click.native="handleShowMember(row)" class="edit" type="warning" size="sm"
                                        icon>
                                        <i class="text-dtac-bt fa fa-user-circle"></i>
                                    </base-button> -->
                                    <base-button
                                        @click.native="handleShowPrintModal(row)" class="edit" type="warning" size="sm"
                                        icon>
                                        <i class="text-dtac-bt fa fa-print"></i>
                                    </base-button>

                                    <!--
                                        Delete-event button (spec 2026-09-23 §8.3). Same gate as the
                                        create button above: canCreateCouponEvent, from config.yml's
                                        coupon_event.emails. Cosmetic only — DELETE /api/v1/coupon/:id
                                        re-checks it (mw.IsCouponEvent), and refuses an event anybody
                                        has registered on (409) whatever the screen thinks.
                                        @click.native matches the sibling buttons in this column.
                                    -->
                                    <base-button v-if="canCreateCouponEvent" :title="$t('coupon_event.delete')"
                                        @click.native="handleDelete(row)" class="edit" type="danger" size="sm"
                                        icon>
                                        <i class="text-white fa fa-trash"></i>
                                    </base-button>

                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0">
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>



        <modal
            :show.sync="showPrintModal"
            modal-classes="modal-secondary modal-lg"
        >
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">
                        สร้าง PDF
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input
                        :label="$t('running_from')"
                        v-model="running_from"
                    ></base-input>
                </div>
                <div class="col-md-6">
                    <base-input
                        :label="$t('running_to')"
                        v-model="running_to"
                    ></base-input>
                </div>
            </div>

			  <template slot="footer">
				<!-- Payment Check Success -->
				<button
                    type="button"
                    class="btn btn-md btn-link ml-auto btn-primary text-white"
                    @click="handleCreatePDF()"
                >
                    {{ $t("create") }}
                </button>
			  </template>

		</modal>



    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import refreshOnArrival from "@/mixins/refreshOnArrival";
import { consumeRefresh } from "@/utils/pageRefresh";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'
import FileInput from "@/components/Inputs/FileInput";
import { undistributeHeight } from '@fullcalendar/core';
import { read, utils, writeFile } from 'xlsx'
import {
    couponEventErrorI18nKeyFor,
    couponEventDeleteBlockedReason
} from "@/utils/couponEvent";

export default {
    mixins: [clientPaginationMixin, refreshOnArrival],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "Coupon/getData",
            isLoading: "Coupon/isLoading",

            isAdmin: "Auth/isAdmin",
            isOwner: "Auth/isOwner",
            isEmployee: "Auth/isEmployee",
            isAgent: "Auth/isAgent",
            // The Auth module is namespaced, so the getter is reached as
            // "Auth/canCreateCouponEvent" — same plumbing as Auth/canViewCost
            // in DashboardLayout.vue:1398.
            canCreateCouponEvent: "Auth/canCreateCouponEvent",
        }),



    },
    data() {
        return {
            propsToSearch: ["po_number", "partner_name", "user_full_name"],
            selectedRows: [],
            params: {
                time_from: "",
                time_to: "",
            },
            isExportLoading: false,
            // Guards against a double-click firing two DELETEs: the second would
            // answer 404 and show the operator an error for a delete that worked.
            isDeleting: false,
            showPrintModal: false,
            running_from: "",
            running_to: "",
            head: {},

        };
    },
    async mounted() {
        // Fresh mount is already fresh: drop a stale flag so the next activation does not refetch.
        consumeRefresh(this.$route.fullPath);
        this.params.time_from = moment().subtract(40, 'days').format('YYYY-MM-DD');
        this.params.time_to = moment().format('YYYY-MM-DD');

        this.listData(this.params);

    },
    methods: {
        ...mapActions({
            listData: "Coupon/listData",
            createData: "Coupon/createData",
            updateData: "Coupon/updateData",
            deleteData: "Coupon/deleteData",
            getDetail: "Coupon/getDetail",
            getCouponDocument : "Coupon/getCouponDocument",

        }),

        // refreshOnArrival mixin: CouponForm saved and navigated back here.
        reloadOnArrival() {
            this.listData(this.params);
        },
        handleSearch() {
            this.listData(this.params);
        },
        handleDetail(row) {
            // go to po page
            this.showDetailModal = true;
            this.orderDetail = row;
            console.log(this.orderDetail)
            this.listDatum({ id: row.ID });
            //
        },

        handleCreate() {
            this.$router.push("/backoffice/coupon/create");
        },
        handleShowPrintModal(row) {
            this.head = row
            this.showPrintModal = true;
        },
        handleShowDetail(row) {
            console.log(row)
            this.$router.push("/backoffice/coupon/detail/" + row.id);
        },
        handleShowMember(row){
            console.log("Show Member",row)
            this.$router.push("/backoffice/coupon/member/" + row.id);
        },

        showCouponEventError(i18nKey, params) {
            swal.fire({
                title: this.$t(i18nKey, params || {}),
                text: "",
                icon: "error",
                confirmButtonClass: "btn btn-danger btn-fill",
                buttonsStyling: false
            });
        },

        // handleDelete — spec 2026-09-23 §8.3.
        //
        // The confirm NAMES the event rather than asking "are you sure?": this
        // list is rows of near-identical campaigns and the delete icon sits next
        // to the print icon, so the only thing that tells the operator they are
        // about to destroy the wrong one is the name in the dialog.
        //
        // The 409 is not an error to apologise for — it is the owner's designed
        // safeguard reporting that it worked — so its message says which counter
        // stopped it, from the counts the server puts in Datum.
        async handleDelete(row) {
            if (!this.canCreateCouponEvent) {
                this.showCouponEventError("coupon_event.errors.coupon_event_forbidden");
                return;
            }
            if (this.isDeleting) return;

            const confirmed = await swal.fire({
                title: this.$t("coupon_event.delete_confirm", { name: row.name }),
                text: this.$t("coupon_event.delete_confirm_detail"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: this.$t("coupon_event.delete_confirm_ok"),
                cancelButtonText: this.$t("coupon_event.cancel"),
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-secondary btn-fill",
                buttonsStyling: false
            });
            if (!confirmed.value) return;

            this.isDeleting = true;
            try {
                const res = await this.deleteData(row.id);
                const datum = (res && res.data && res.data.Datum) || {};

                await swal.fire({
                    title: this.$t("coupon_event.deleted"),
                    text: this.$t("coupon_event.deleted_detail", {
                        codes: datum.codes_deleted != null ? datum.codes_deleted : 0
                    }),
                    icon: "success",
                    confirmButtonClass: "btn btn-success btn-fill",
                    buttonsStyling: false
                });

                // Re-list rather than splicing the row out of `tableData`:
                // tableData IS the Vuex state array (Coupon/getData), so a local
                // splice would mutate the store from a component, and the list's
                // per-row counts come from the server anyway.
                this.listData(this.params);
            } catch (err) {
                const status = (err && err.response && err.response.status) || 0;
                const data = (err && err.response && err.response.data) || {};

                if (status === 409) {
                    const counts = data.Datum || {};
                    this.showCouponEventError(
                        couponEventDeleteBlockedReason(counts) ||
                            "coupon_event.errors.coupon_event_in_use",
                        { registered: counts.registered || 0, used: counts.used || 0 }
                    );
                } else if (status === 403) {
                    this.showCouponEventError("coupon_event.errors.coupon_event_forbidden");
                } else if (status === 404) {
                    this.showCouponEventError("coupon_event.errors.coupon_event_not_found");
                    // The row the operator clicked is not there any more — refresh
                    // rather than leaving a ghost they can click again.
                    this.listData(this.params);
                } else {
                    // The fallback names DELETE, not "create": the generic
                    // coupon_event.errors.unknown would tell an operator whose
                    // delete hit a 500 that a creation they never attempted
                    // failed.
                    this.showCouponEventError(
                        couponEventErrorI18nKeyFor(data.Msg, "unknown_delete")
                    );
                }
            } finally {
                this.isDeleting = false;
            }
        },
        handleCreatePDF(){
            // show wating modal

            // check running_from and running_to
            if(this.running_from == "" || this.running_to == ""){
                swal.fire({
                    title: "กรุณากรอกหมายเลขคูปอง",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            // to- from must be less than 10
            let fromInt = parseInt(this.running_from)
            let toInt = parseInt(this.running_to)
            if(toInt - fromInt > 15){
                swal.fire({
                    title: "กรุณากำหนดช่วงคูปองไม่เกิน 15 หมายเลข",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            // check running_from and running_to is valid


            swal.close();
            swal.fire({
                title: "กำลังดาวน์โหลด",
                text: "กรุณารอสักครู่",
                icon: "info",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            this.getCouponDocument({id:this.head.id,running_from: this.running_from, running_to: this.running_to}).then(resp => {
				// url = api path
				swal.close();
				let url = process.env.VUE_APP_API_BASE_URL + "/files/coupons/" + resp.data.Datum.url
				window.open(url, '_blank');
			}).catch(err => {
				swal.fire({
					title: err.response.data.Cause,
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			});
        }

    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
